import { Type } from 'class-transformer';
import { IsOptional, ValidateNested } from 'class-validator';
import { IsMongoIdObject } from '../../../decorators/is-mongo-object-id.decorator';
import { TokenVaultId } from '../../../types';
import { BetaRegistrationPopulateDto } from '../../business/etxe';
import { UserRegistrationCreatedByPopulateDto } from '../../user-registration';
import { UserCreatedByPopulateDto } from '../../users';

export class EmailContextDto {
  @ValidateNested()
  @Type(() => UserCreatedByPopulateDto)
  @IsOptional()
  user?: UserCreatedByPopulateDto;

  @ValidateNested()
  @Type(() => UserRegistrationCreatedByPopulateDto)
  @IsOptional()
  userRegistration?: UserRegistrationCreatedByPopulateDto;

  @ValidateNested()
  @Type(() => BetaRegistrationPopulateDto)
  @IsOptional()
  betaRegistration?: BetaRegistrationPopulateDto;

  @IsMongoIdObject()
  @IsOptional()
  tokenVault?: TokenVaultId;
}
